import { render } from "./hoverEffect2.vue?vue&type=template&id=10a3dfc4"
import script from "./hoverEffect2.vue?vue&type=script&lang=js"
export * from "./hoverEffect2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__